var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "actions-collapsed-list" }, [
    _c(
      "a",
      {
        staticClass: "btn btn-function exit-collapsed-list",
        on: { click: _vm.collapseActions }
      },
      [
        _c("i", {
          staticClass: "glyphicon glyphicon-chevron-left",
          attrs: {
            "aria-hidden": "true",
            "tooltip-placement": "right",
            "uib-tooltip": "Cancel"
          }
        })
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "action-icon" }, [
      _c(
        "a",
        { staticClass: "btn btn-list-function", on: { click: _vm.showForm } },
        [
          _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.bottom.hover",
                value: { text: _vm.$t("GROUP_ACTIONS_EDIT"), transition: 0 },
                expression: "{text:$t('GROUP_ACTIONS_EDIT'), transition: 0}",
                modifiers: { bottom: true, hover: true }
              }
            ],
            staticClass: "typcn typcn-edit",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("span", {
            directives: [
              { name: "t", rawName: "v-t", value: "EDIT", expression: "'EDIT'" }
            ],
            staticClass: "hint-text-mobile"
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "action-icon m-t-2" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-list-function",
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.showInvites }
        },
        [
          _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.bottom.hover",
                value: { text: _vm.$t("MANAGE_USER_INVITES"), transition: 0 },
                expression: "{text:$t('MANAGE_USER_INVITES'), transition: 0}",
                modifiers: { bottom: true, hover: true }
              }
            ],
            staticClass: "fa fa-user-plus",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("span", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "MANAGE_USER_INVITES",
                expression: "'MANAGE_USER_INVITES'"
              }
            ],
            staticClass: "hint-text-mobile"
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "action-icon" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-list-function",
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.confirmDeleteModal }
        },
        [
          _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.bottom.hover",
                value: { text: _vm.$t("GROUP_ACTIONS_DELETE"), transition: 0 },
                expression: "{text:$t('GROUP_ACTIONS_DELETE'), transition: 0}",
                modifiers: { bottom: true, hover: true }
              }
            ],
            staticClass: "typcn typcn-trash",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("span", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "DELETE",
                expression: "'DELETE'"
              }
            ],
            staticClass: "hint-text-mobile"
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }